<div class="avatar-container">
  <p-avatarGroup>
    <p-avatar
      class="main-avatar"
      [image]="image"
      [label]="initials"
      size="xlarge"
      shape="circle" />
    @if (countryImage) {
      <p-avatar
        class="country-avatar"
        [image]="countryImage"
        size="xlarge"
        shape="circle" />
    }
  </p-avatarGroup>
</div>
